import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { LabelService } from 'src/app/shared/services/label.service';

@Component({
  selector: 'app-terms-page',
  templateUrl: './terms-page.component.html',
  styleUrls: ['./terms-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class TermsPageComponent implements OnInit {
  i18n = this.labelService.labels;
  infoContent!:string;
   constructor(
      private readonly labelService: LabelService,
      @Inject(DIALOG_DATA) protected data: {event:string},
      public dialogRef: DialogRef<boolean>
    ) {
    }
    ngOnInit():void{
      if(this.data && this.data?.event ===  'ingress'){
         this.infoContent = this.i18n.TERMS_CONDITIONS.INGRESS_DESC;
       }else {
        this.infoContent = this.i18n.TERMS_CONDITIONS.INITIAL_LOAD_DESC;
       }
    }
    onDecline() {
      this.dialogRef.close(false);
    }
    onAccept(){
      this.dialogRef.close(true);
    }
}
